module.exports = __webpack_public_path__ + "img/payx.5b6325c2.svg";